import React from 'react';
import {t} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {escapeBracketText} from '../../../domain/common/util/escapeBracketText';
import {theme} from '../../../theme';
import {Divider} from '../../atoms/Divider/Divider';
import {Text} from '../../atoms/Text/Text';
import {MoreExpandListDetail} from '../MoreExpandListDetail/MoreExpandListDetail';
import {MoreExpandListItem} from '../MoreExpandListItem/MoreExpandListItem';
import {MoreExpandAskListProps} from './MoreExpandAskList.interface';

const MoreExpandAskList = React.forwardRef<HTMLElement, MoreExpandAskListProps>(
  (
    {isActive, isLabelBadge, isResolved, title, createDt, detail, ...props},
    ref
  ) => (
    <>
      <MoreExpandListItem
        ref={isActive ? ref : null}
        isActive={isActive}
        isLabelBadge={isLabelBadge}
        isResolved={isResolved}
        title={title}
        createDt={createDt}
        createDtFormat={t('date_formatter_year_full_dot')}
        data-test="ask-my-item"
        {...props}
      />
      {detail.map(({content}, index) => {
        /**
         * 사용자가 입력한 내용(index === 0)은 HTML, XSS 방지를 위해 dangerouslySetInnerHTML 사용하지 않고,
         * 운영자(비교적 안전)가 입력한 내용(index > 0)만 dangerouslySetInnerHTML 사용
         *
         * 관련이슈
         * https://kakaoent.atlassian.net/browse/KW-9405
         * https://kakaoent.atlassian.net/browse/KW-9351
         */
        const isUserContent = index === 0;
        const contents = isUserContent ? content : escapeBracketText(content);
        return (
          <React.Fragment key={index}>
            {index !== 0 && (
              <Divider color={theme.colors['theme-transparent-10']} />
            )}
            <div
              key={index}
              className={twMerge(
                'flex-col items-start bg-theme-bg-surface-alt gap-[4px] p-[24px_15px]',
                isActive ? 'flex' : 'hidden'
              )}
            >
              <Text className="font-small1-bold text-theme-solid-100">
                {index === 0
                  ? t('more_customer_cs_history_tab_detail_question')
                  : t('more_customer_cs_history_tab_detail_answer')}
              </Text>
              <MoreExpandListDetail
                isActive={isActive}
                contents={contents}
                className="p-0 whitespace-pre-wrap break-word-anywhere"
                data-test="ask-my-item-detail"
                useDangerouslySetInnerHTML={index > 0}
              />
            </div>
          </React.Fragment>
        );
      })}
    </>
  )
);

MoreExpandAskList.displayName = 'MoreExpandAskList';

export {MoreExpandAskList};
